import React from 'react'
import { YoutubePlayer as ZionYoutubePlayer } from '@fs/zion-video'
import { NoConsentView } from './NoConsentView'

export default function YoutubePlayer({
  noConsentView,
  ...props
}: React.ComponentProps<typeof ZionYoutubePlayer>): JSX.Element {
  return <ZionYoutubePlayer noConsentView={noConsentView || <NoConsentView />} {...props} />
}
